"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconTranslationActive = Experimental__IconTranslationActive;
exports.IconTranslationActive = IconTranslationActive;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconTranslationActive/index.tsx)
 */
function IconTranslationActive(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M11.605 10.674H9.854l.876-2.004.875 2.004z\'/><path d=\'M1 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm5.515 2.027v.744H9.26a.75.75 0 1 1 0 1.5h-.983a6.403 6.403 0 0 1-1.429 3.713 4.564 4.564 0 0 0 2.174.848l1.02-2.336a.75.75 0 0 1 1.375 0l3 6.867a.75.75 0 0 1-1.375.6l-.782-1.789H9.2l-.782 1.79a.75.75 0 1 1-1.375-.6l1.359-3.11A6.07 6.07 0 0 1 5.76 9.04a6.4 6.4 0 0 1-3.403 1.302.75.75 0 0 1-.116-1.495A4.9 4.9 0 0 0 4.7 7.958a6.07 6.07 0 0 1-1.06-2.2.75.75 0 1 1 1.455-.365c.138.55.375 1.06.693 1.512a4.902 4.902 0 0 0 .985-2.634H2.271a.75.75 0 0 1 0-1.5h2.744v-.744a.75.75 0 0 1 1.5 0z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'m15.753 12.842 1.252 2.866h-2.504l1.252-2.866z\'/><path d=\'M3 1a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3zm6.928 2.787v1.054h3.805a1 1 0 1 1 0 2H12.35a8.773 8.773 0 0 1-1.98 5.142 6.308 6.308 0 0 0 3.053 1.194l1.413-3.233a1 1 0 0 1 1.833 0l4.124 9.443a1 1 0 1 1-1.832.8l-1.083-2.479h-4.251l-1.083 2.48a1 1 0 1 1-1.833-.8l1.883-4.313a8.314 8.314 0 0 1-3.674-1.684 8.77 8.77 0 0 1-4.68 1.799 1 1 0 1 1-.155-1.995 6.769 6.769 0 0 0 3.423-1.245 8.317 8.317 0 0 1-1.471-3.04 1 1 0 0 1 1.94-.488 6.29 6.29 0 0 0 .981 2.125 6.772 6.772 0 0 0 1.39-3.706H4.122a1 1 0 1 1 0-2h3.806V3.787a1 1 0 1 1 2 0z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconTranslationActive is deprecated and will be archived soon. Use IconTranslationActive instead.
 */
function Experimental__IconTranslationActive(props) {
  return /*#__PURE__*/_react["default"].createElement(IconTranslationActive, props);
}